import axios from 'axios'

const { REACT_APP_WP_SITE_URI } = process.env

const api = (prefix = 'wp', withCredentials = false, version = 2) => axios.create({
  baseURL: `${REACT_APP_WP_SITE_URI}/wp-json/${prefix}/v${version}/`,
  withCredentials,
})
const acfApi = api('acf', false, 3)
const gFormApi = api('gf', true)
const wpApi = api()

export {
  acfApi,
  gFormApi,
  wpApi,
}
